export function shipmentNumber(id: any): string {
    const num = parseInt(id, 10);
    return (440000000 + (num * 11)).toString(10);
}
